var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 218,
    viewBox: "0 0 218 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218 109C218 169.199 169.199 218 109 218C48.801 218 0 169.199 0 109C0 48.801 48.801 0 109 0C169.199 0 218 48.801 218 109Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109 216.59C168.42 216.59 216.59 168.42 216.59 109C216.59 49.5797 168.42 1.41 109 1.41C49.5797 1.41 1.41 49.5797 1.41 109C1.41 168.42 49.5797 216.59 109 216.59ZM109 218C169.199 218 218 169.199 218 109C218 48.801 169.199 0 109 0C48.801 0 0 48.801 0 109C0 169.199 48.801 218 109 218Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180 109C180 148.212 148.212 180 109 180C69.7878 180 38 148.212 38 109C38 69.7878 69.7878 38 109 38C148.212 38 180 69.7878 180 109Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.52 100.162C157.31 74.9592 135.398 55.75 109 55.75V38C145.213 38 175.093 65.1106 179.453 100.143C180.058 105.007 176.027 109 171.125 109C166.223 109 162.328 104.997 161.52 100.162Z",
    fill: "#6CD28B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.25 109C162.25 138.409 138.409 162.25 109 162.25C79.5908 162.25 55.75 138.409 55.75 109C55.75 79.5908 79.5908 55.75 109 55.75C138.409 55.75 162.25 79.5908 162.25 109Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/Insights.af2d0f2270bc8f2e5961923b1edb5339.svg";
export { ForwardRef as ReactComponent };